import {
  ImagePromptCard,
  LoadingState,
  WaveBackgroundLayout,
} from "~/common/components";
import SuccessIcon from "~/common/components/layouts/SuccessIcon";

interface ConsultationCompletedProps {
  title: string;
  subtitle: string;
  isLoading: boolean;
  isPending: boolean;
  isNavigatingBack: boolean;
  handleComplete: () => void;
  handleGoBackFinalScreen: () => void;
  continueLabel: string;
}
export const ConsultationCompleted = ({
  handleGoBackFinalScreen,
  title,
  subtitle,
  isLoading,
  isPending,
  isNavigatingBack,
  handleComplete,
  continueLabel,
}: ConsultationCompletedProps) => {
  if (isLoading) return <LoadingState className="h-screen-calculated" />;

  return (
    <WaveBackgroundLayout className="relative justify-center p-6">
      <ImagePromptCard
        title={title}
        subtitle={subtitle}
        handleContinue={handleComplete}
        handleGoBack={handleGoBackFinalScreen}
        pendingContinue={isPending}
        isNavigatingBack={isNavigatingBack}
        continueLabel={continueLabel}
        imageContainerClassName="bg-green-100"
      >
        <SuccessIcon className="w-full" />
      </ImagePromptCard>
    </WaveBackgroundLayout>
  );
};
